import { createAction } from "typesafe-actions";

import { createNamespacedAction } from "app/pages/sales-intelligence/store/utils";

import type { FilterCategory } from "../types/category";
import type { FilterModeType } from "../types/misc";

const createAdvancedSearchFilteringAction = createNamespacedAction("si/advanced-search-filtering");

export const updateIsNewOnlyAction = createAdvancedSearchFilteringAction<boolean>("is-new-only-updated");

export const setSelectedFilterCategory = createAdvancedSearchFilteringAction<FilterCategory>(
    "filters-panel/set-selected-filter-category",
);

export const setIsFiltersCategoriesPanelExpanded = createAdvancedSearchFilteringAction<boolean>(
    "filters-panel/set-is-filters-categories-panel-expanded",
);

export const setIsFiltersPanelExpanded = createAdvancedSearchFilteringAction<boolean>(
    "filters-panel/set-is-filters-panel-expanded",
);

export const setExpandedFilterName = createAdvancedSearchFilteringAction<string | null>(
    "filters-panel/set-expanded-filter-name",
);

export const setFilterMode = createAdvancedSearchFilteringAction<FilterModeType>("filters-panel/set-filter-mode");

export const setSearchQuery = createAdvancedSearchFilteringAction<string>("filters-panel/set-search-query");

// `createNamespacedAction` widens the tag to `@@${string}/${string}`, so a second payload-less action
// is structurally identical to `resetFilteringStateAction` and the two collide in the reducer's action
// union. A literal tag (same runtime value the helper would produce) keeps this action distinct.
export const markInitialFiltersReady = createAction(
    "@@si/advanced-search-filtering/filters-panel/mark-initial-filters-ready",
)();

export const resetFilteringStateAction = createAdvancedSearchFilteringAction("reset");
